export const PermissionActions = {
  CREATE: 'create',
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  MANAGE: 'manage',
  LIST: 'list',
  CHANGE_PASSWORD: 'changePassword',
  VERIFY: 'verify',
  ALL: '*',
};

export const PermissionSubjects = {
  TENANT: 'tenant',
  CLIENT: 'client',
  AGENT: 'agent',
  USER: 'user',
};
